/**
 * Known risk flags, derived from free-text entries in
 * care_recipients.conditions.
 *
 * The conditions array is user-authored (onboarding + Ginie), so matching is
 * done on lowercased substrings rather than exact equality.
 */
export const RISK_FLAGS = [
  {
    key: 'fall',
    label: 'Fall risk',
    severity: 'high',
    reason: 'A fall while alone can go unnoticed for hours. Check footwear, lighting, and clear paths.',
    match: ['fall risk', 'falls', 'fall', 'unsteady', 'balance'],
  },
  {
    key: 'medication',
    label: 'Medication gaps',
    severity: 'high',
    reason: 'Missed doses are the most common cause of avoidable decline. Worth a daily prompt.',
    match: ['medication gap', 'medication non-compliance', 'skips medication', 'non-compliance', 'polypharmacy'],
  },
  {
    key: 'loneliness',
    label: 'Loneliness',
    severity: 'medium',
    reason: 'Social isolation accelerates cognitive and mood decline. Regular contact protects against it.',
    match: ['lonely', 'loneliness', 'isolated', 'isolation', 'socially isolated'],
  },
  {
    key: 'wandering',
    label: 'Wandering',
    severity: 'high',
    reason: 'Leaving home unaccompanied and becoming disoriented is an urgent safety concern.',
    match: ['wandering', 'wanders', 'elopement'],
  },
  {
    key: 'uti',
    label: 'UTI prone',
    severity: 'medium',
    reason: 'Recurrent UTIs often present as sudden confusion rather than obvious infection.',
    match: ['uti', 'urinary tract'],
  },
]

/** Returns the risk flags implied by a conditions array. */
export function matchRiskFlags(conditions) {
  const list = (conditions || []).map((c) => String(c).toLowerCase())
  if (list.length === 0) return []
  return RISK_FLAGS.filter((f) =>
    f.match.some((m) => list.some((c) => c.includes(m)))
  )
}
